import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import alertPoliciesClient, { AlertPolicy } from "../../../api/alertPolicies";

const QUERY_KEY = ["alert-policies"];

export const useAlertPolicies = () =>
  useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => alertPoliciesClient.list(),
  });

export const useCreateAlertPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<AlertPolicy>) =>
      alertPoliciesClient.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useUpdateAlertPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<AlertPolicy> }) =>
      alertPoliciesClient.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeleteAlertPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => alertPoliciesClient.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
